$ ->

  QUEUE_STARTED = 'started'
  QUEUE_FINISHED = 'finished'
  QUEUE_WAITING = 'not_processed'

  ACTION_BUTTONS_SELECTOR = '[data-bulk-edit-form-action]'

  form = $('form[action*="/bulk_edit/"]')
  bToken = form.data('token')

  pollQueueState = (token) ->
    $.ajax
      url: '/ajax/v2/queue/poll'
      data:
        token: token
      method: 'POST'

  errorHandler = (message = '') ->
    $(ACTION_BUTTONS_SELECTOR).each (i,e) ->
      $(e).removeAttr 'disabled'
      $(e).hideLoader()
    Loader.hide()
    additional = (if message then ": <strong>#{message}</strong>" else "")
    INTENT.utils.Notify.danger "#{__('bulk_edit_error')}#{additional}", {auto_hide: no}

  showLoader = (percents, message) ->
    progress = $('.progress-container')
    if progress.length
      $('.progress-bar').css('width', "#{percents}%")
      if message != undefined
        $('.progress-container .progress-text').html message
      progress.show();
    else
      if message != undefined
        Loader.show {text: message}
      else
        Loader.show()

  add_hidden = (value) ->
    if not $('[name="include[]"]').filter("[value='#{value}']").length
      $('<input>', {
        type: 'hidden'
        name: 'include[]'
        value: value
      }).appendTo form

  hideLoader = ->
    progress = $('.progress-container')
    if progress.length
      $('.progress-container .progress-text').text ''
      progress.hide()
    else
      Loader.hide()

  showRunningQueueState = (resp) ->
    waiting_max_polls = 20
    waiting_current_poll = 0
    if resp.status
      poll = setInterval ->
        pollQueueState(bToken).done (r) ->
          if r.status
            if r.state == QUEUE_STARTED and r.percents > 0
              form.hide()
              $('.bulk_edit__campaigns_list').hide()
              $('#subtitle').text(__('processing_please_wait'))
              showLoader r.percents, __('bulk_edit_processing_eta', {':percents': "<strong>#{r.percents} %</strong>", ':eta': r.remaining_time})
            else if r.state == QUEUE_WAITING or (r.state == QUEUE_STARTED and r.percents == 0)
              $('#subtitle').text(__('processing_please_wait'))
              showLoader 0, '0 %'
              form.hide()
              waiting_current_poll += 1
              if waiting_current_poll > waiting_max_polls
                clearInterval poll
                hideLoader()
                INTENT.utils.Notify.danger __('bulk_edit_error')
            else if r.state == QUEUE_FINISHED
              clearInterval poll
              form.hide()
              $('.bulk_edit__campaigns_list').hide()
              $('#subtitle').text('')
              $(ACTION_BUTTONS_SELECTOR).hideLoader()
              showLoader 100, __('bulk_edit_all_done')
              $('.progress-container .btn').show()
              $(document).on('click', '.progress-container .btn', (e) ->
                  $(e.target).showLoader()
                  window.location.href = form.prop('action').replace /\/bulk_edit.*$/, '/list'
              )
          else
            clearInterval poll
            errorHandler r.error
        .fail ->
          clearInterval poll
          errorHandler()
      , 3000
    else if 'error' of resp and resp.error
      errorHandler resp.error

  disable_buttons = () ->
    $(ACTION_BUTTONS_SELECTOR).attr 'disabled', 'disabled'

  enable_buttons = () ->
    $(ACTION_BUTTONS_SELECTOR).removeAttr 'disabled'

  # show queue processing if queue failed or running
  if bToken
    pollQueueState(bToken).done (r) ->
      if not r.status or r.state == QUEUE_STARTED
        showRunningQueueState r

  $(document).on 'click', ACTION_BUTTONS_SELECTOR, (e) ->
    btn = $ e.target
    if btn.attr('disabled')
      e.preventDefault()
      return false

    disable_buttons()
    action = btn.attr('data-bulk-edit-form-action').toLowerCase()
    btn.showLoader()

    if action is 'next'
      form.submit()
    else if action is 'apply'
      campaigns = {}
      modified_campaigns = {}
      $('.bulk_edit__diff_campaign').each (key, item) ->
        item = $ item
        id = item.attr('data-campaign-id')
        name = item.attr('data-campaign-name')
        add_hidden id
        if item.attr('data-changed') == '1'
          modified_campaigns[id] =  "##{id} <strong>#{name}</strong>"
        else
          campaigns[id] = "##{id} <strong>#{name}</strong>"

      apply = ->
        if _.size(campaigns) or _.size(modified_campaigns)
          if not _.size(campaigns)
            campaigns = modified_campaigns
          campaigns_msg = "<div class='bulk_edit__alert_campaigns'>#{_.values(campaigns).join('<br>')}</div>"
          show_confirm(
            __('campaigns.bulk-edit.save-confirm', {':campaigns': campaigns_msg})
            () ->
              btn.showLoader()
              $.ajax
                url: form.attr 'action'
                method: 'POST'
                data: form.serialize()
              .done (resp) ->
                showRunningQueueState(resp)
              .fail ->
                errorHandler()
            () ->
              btn.hideLoader()
              enable_buttons()
          )
        else
          btn.hideLoader()
          enable_buttons()
          INTENT.utils.Notify.warning __('campaigns.bulk-edit.save-confirm.empty-list')


      if _.size(modified_campaigns)
        campaigns_msg = "<div class='bulk_edit__alert_campaigns'>#{_.values(modified_campaigns).join('<br>')}</div>"
        btn.hideLoader()
        show_confirm(
          __('diff.object_was_changed.warning', {':campaigns': campaigns_msg})
          () ->
            enable_buttons()
          () ->
            apply()
          __('close_and_check'),
          __('ignore_and_continue')
        )
      else
        apply()
